<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.home.Historico_accesos') }}</span>
          </div>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <TableHistoricalAccessControl></TableHistoricalAccessControl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TableHistoricalAccessControl from '@/components/TableHistoricalAccessControl.vue';

export default {
  name: 'HistoricalAccessControl',
  components: {
    TableHistoricalAccessControl
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
